import { render, staticRenderFns } from "./editcol.vue?vue&type=template&id=88df3eaa&scoped=true&"
import script from "./editcol.vue?vue&type=script&lang=js&"
export * from "./editcol.vue?vue&type=script&lang=js&"
import style0 from "./editcol.vue?vue&type=style&index=0&id=88df3eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88df3eaa",
  null
  
)

export default component.exports